import { render, staticRenderFns } from "./ChoiceOptions.vue?vue&type=template&id=01fed468&"
import script from "./ChoiceOptions.vue?vue&type=script&lang=js&"
export * from "./ChoiceOptions.vue?vue&type=script&lang=js&"
import style0 from "./../../node_modules/vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./../../node_modules/vue-swatches/dist/vue-swatches.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./ChoiceOptions.vue?vue&type=style&index=2&id=01fed468&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports